import FilterConstants from '../../../../filter-constants';
import * as CircuitUtils from '../../../utils/circuit';

export function computeLimits(c1IdealValue, r1IdealValue, l1IdealValue) {
  let capacitorMinimumLimitMultiplier = computeCapacitorMinimumLimitMultiplier(c1IdealValue, l1IdealValue);
  let capacitorMaximumLimitMultiplier = computeCapacitorMaximumLimitMultiplier(c1IdealValue, l1IdealValue);
  let Q = r1IdealValue * Math.sqrt(c1IdealValue / l1IdealValue);
  let c1BigLimits = computeC1BigLimits(c1IdealValue, l1IdealValue, capacitorMaximumLimitMultiplier, Q);
  let c1TinyLimits = computeC1TinyLimits(c1IdealValue, l1IdealValue, capacitorMinimumLimitMultiplier, Q);
  return {
    c1Minimum: c1TinyLimits.c1Tiny,
    c1Maximum: c1BigLimits.c1Big,
    r1Minimum: c1BigLimits.r1Tiny,
    r1Maximum: c1TinyLimits.r1Big,
    l1Minimum: c1BigLimits.l1Tiny,
    l1Maximum: c1TinyLimits.l1Big,
  };
}

export function computeGainResistorLimitMultipliers(r3IdealValue, r4IdealValue) {
  let minMultiplier = CircuitUtils.getResistorMinimumLimitMultiplier(r3IdealValue, r4IdealValue);
  let maxMultiplier = computeResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  return {
    resistorMinimumLimitMultiplier: minMultiplier,
    resistorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue) {
  var maxLimit = CircuitUtils.getResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  var result = maxLimit;
  var rBig = r4IdealValue * maxLimit;
  if (rBig > 100e3) {
    result = (result * 100e3) / rBig;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, l1IdealValue) {
  var smallCapLimit = FilterConstants.Limits.CSMALL_COMP_LIMIT * 2; //20 pF
  var result = smallCapLimit / c1IdealValue;
  var l1Big = l1IdealValue / result;

  if (l1Big > FilterConstants.Limits.LBIG_COMP_LIMIT) {
    result = (l1Big / FilterConstants.Limits.LBIG_COMP_LIMIT) * result;
  }

  return result;
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, l1IdealValue) {
  var result = FilterConstants.Limits.CBIG_COMP_LIMIT / c1IdealValue;
  var l1Tiny = l1IdealValue / result;

  if (l1Tiny < FilterConstants.Limits.LSMALL_COMP_LIMIT) {
    result = (l1Tiny / FilterConstants.Limits.LSMALL_COMP_LIMIT) * result;
  }

  return result;
}

function computeC1BigLimits(c1IdealValue, l1IdealValue, capacitorMaximumLimitMultiplier, Q) {
  let l1Tiny = l1IdealValue / capacitorMaximumLimitMultiplier;
  let c1Big = c1IdealValue * capacitorMaximumLimitMultiplier;
  let r1Tiny = Q / Math.sqrt(c1Big / l1Tiny);

  let multiplier = 1;
  let smallResLimit = FilterConstants.Limits.RSMALL_COMP_LIMIT * 20; //20 ohms
  if (r1Tiny < smallResLimit) {
    multiplier = r1Tiny / smallResLimit;
  }

  return {
    l1Tiny: l1Tiny / multiplier,
    c1Big: c1Big * multiplier,
    r1Tiny: r1Tiny < smallResLimit ? smallResLimit : r1Tiny,
  };
}

function computeC1TinyLimits(c1IdealValue, l1IdealValue, capacitorMinimumLimitMultiplier, Q) {
  let l1Big = l1IdealValue / capacitorMinimumLimitMultiplier;
  let c1Tiny = c1IdealValue * capacitorMinimumLimitMultiplier;
  let r1Big = Q / Math.sqrt(c1Tiny / l1Big);

  let multiplier = 1;
  if (r1Big > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    multiplier = r1Big / FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return {
    l1Big: l1Big / multiplier,
    c1Tiny: c1Tiny * multiplier,
    r1Big: r1Big > FilterConstants.Limits.RBIG_COMP_LIMIT ? FilterConstants.Limits.RBIG_COMP_LIMIT : r1Big,
  };
}
